<template>
  <div class="fade-in">
    <section class="hero is-fullheight">
      <div class="hero-body is-paddingless">
        <div class="container is-paddingless">
          <div class="columns is-paddingless">
            <div class="column is-6-desktop is-offset-3-desktop is-paddingless">
              <div class="card">
                <div class="card-content">
                  <h2 class="title">Login</h2>
                  <form @submit.prevent="onSubmit">
                    <div class="field">
                      <label class="label">Email</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="email"
                          v-model="user.email"
                          placeholder="Email"
                          autofocus
                          required
                        />
                        <span class="icon is-small is-left"
                          ><i class="fa fa-envelope"></i
                        ></span>
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Password</label>
                      <div class="control has-icons-left has-icons-right">
                        <input
                          class="input"
                          type="password"
                          v-model="user.password"
                          placeholder="Password"
                          required
                        />
                        <span class="icon is-small is-left"
                          ><i class="fa fa-lock"></i
                        ></span>
                      </div>
                    </div>

                    <div class="field is-grouped">
                      <div class="control">
                        <button
                          :class="[
                            'button',
                            'is-primary',
                            'is-large',
                            { 'is-loading': loading }
                          ]"
                        >
                          Login
                        </button>
                      </div>
                      <div class="control">
                        <router-link
                          :to="{ name: 'forgot-password' }"
                          class="button is-link"
                          style="margin-top: 8px;"
                          >Forgot password?
                        </router-link>
                      </div>
                      <div class="is-clearfix"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-toastr ref="toastr"></vue-toastr>
    </section>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import AuthService from "@/services/AuthService";

export default {
  name: "login",

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      user: {
        email: "",
        password: ""
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      AuthService.login(this.user)
        .then(() => {
          this.loading = false;
          if (this.$can("patient_queue:read|patient_queue:manage")) {
            this.$router.push({ name: "patient-queue-list" });
          } else {
            this.$router.push({ name: "encounter-list" });
          }
        })
        .catch(response => {
          this.loading = false;
          this.$refs.toastr.e(
            "Sorry, we cannot find your account. Please check your email/password."
          );
        });
    }
  }
};
</script>

<style lang="scss">
.login {
  .navbar,
  .aside {
    display: none;
  }

  .column.col-content.is-9-desktop.is-10-widescreen.is-three-quarters-tablet.is-mobile {
    width: 100%;
    padding: 0;
  }

  section.section {
    padding: 0;
  }

  .card-content {
    padding: 2.14rem;
  }
}
</style>
